export default __webpack_public_path__ + "static/media/photo--lg--hockey2.5de17582.jpg";